// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"a0c44b6d","453":"8ac09f1f"}[chunkId] + ".chunk.js";
};